// removed by extract-text-webpack-plugin
module.exports = {"Container":"Vacc__Container__39qUw","Vaccination":"Vacc__Vaccination__1VY-X","UniqueSpan":"Vacc__UniqueSpan__35DpU","Btn":"Vacc__Btn__1kbj_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VaccinationController/Vacc/Vacc.css
// module id = 124
// module chunks = 0